import { css } from '@emotion/react';
import { CSSInterpolation } from '@emotion/serialize';
import { ReactElement, RefObject, useCallback, useEffect, useState } from 'react';

import { TOOLTIP_HALF_RHOMBUS } from '.';

type Interface = {
	children: string;
	className?: string;
	tooltipRef: RefObject<HTMLDivElement>;
	styles: CSSInterpolation;
	fieldRef?: RefObject<HTMLDivElement>;
};
export const StickyTooltip = ({ className, children, fieldRef, styles, tooltipRef }: Interface): ReactElement => {
	const [pos, setPos] = useState({ top: '', left: '50%' });

	const posDetermination = useCallback((): void => {
		const el = fieldRef?.current;
		if (el) {
			const { y, height, left, right } = el.getBoundingClientRect(),
				middle = (right - left) / 2,
				result = left + middle;

			setPos({
				top: y - height - TOOLTIP_HALF_RHOMBUS + 'px',
				left: result + 'px',
			});
		}
	}, [fieldRef]);

	useEffect(() => {
		posDetermination();
	}, [posDetermination]);

	return (
		<div
			ref={tooltipRef}
			css={css`
				div& {
					position: ${fieldRef ? 'fixed' : 'absolute'};
					z-index: 100000;
					${styles};
					${pos};
					&::after {
						bottom: -5px;
					}
				}
			`}
			className={className}
		>
			{children}
		</div>
	);
};
